import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';
import { of } from 'rxjs';

const submitShellDisplay: IShellDisplay = {
  route: '/pages/ac-request/submit',
  navTitleKey: l10n('AC_REQUEST.SUBMIT.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:pencil-write-2',
  hideNavBar$: of(true),
};

const cloneShellDisplay: IShellDisplay = {
  route: '/pages/ac-request/clone',
  navTitleKey: l10n('AC_REQUEST.CLONE.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:pencil-write-2',
  hideNavBar$: of(true),
};

const unitScheduleShellDisplay: IShellDisplay = {
  route: '/pages/ac-request/unit-schedule',
  navTitleKey: l10n('AC_REQUEST.UNIT_SCHEDULE.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:volume-up',
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: SHELL_DISPLAY, useValue: submitShellDisplay, multi: true },
    { provide: SHELL_DISPLAY, useValue: cloneShellDisplay, multi: true },
    { provide: SHELL_DISPLAY, useValue: unitScheduleShellDisplay, multi: true },
  ],
})
export class AcRequestMetadataModule {}
